import debounce from "./debounce";

let navigation = {
    $itemToggle: undefined,
    $menuToggle: undefined,
    $menu: undefined,
    debounce: debounce.new(),

    menuToggleInit() {
        navigation.$menuToggle.on("click", function(e) {
            e.preventDefault();
            jQuery(this).toggleClass("open");
            navigation.$menu.toggleClass("open");

            if (!navigation.$menu.hasClass("open")) {
                navigation.$menu.find(".dropdown").removeClass("open");
            }
        });
    },

    itemToggleInit() {
        navigation.$itemToggle.on("click", function(e) {
            e.preventDefault();
            jQuery(this)
                .parent(".dropdown")
                .toggleClass("open");
        });
        navigation.$itemToggle.parent('.dropdown').first().children('a[href="#"]').on("click", function(e){
            e.preventDefault();
            jQuery(this)
                .parent(".dropdown")
                .toggleClass("open");
        });//links with a hash toggle their sub menu
    },

    handleResize() {
        if (navigation.$itemToggle.css("display") === "none") {
            jQuery(".dropdown.open").removeClass("open");
        }
    }
};

export default function() {
    navigation.$itemToggle = jQuery(".js-item-toggle");
    navigation.$menu = jQuery(".js-navigation-menu");
    navigation.$menuToggle = jQuery(".js-menu-toggle");

    navigation.itemToggleInit();
    navigation.menuToggleInit();

    $(window).resize(function() {
        navigation.debounce.set(navigation.handleResize, 500);
    });
}
